import type { PaymentStatus } from '@/types/models';

const paymentStatusEnumMapEnum = {
    NEW: 1,
    PENDING_APPROVAL: 2,
    REQUESTED: 3,
    SCHEDULED: 4,
    PROCESSED: 5,
    FAILED: 6,
    RETURNED: 7,
    REJECTED: 8,
    CANCELED: 9,
    APPROVED: 10,
    RETRIED: 11,
} as const;

export type PaymentStatusEnumKeys = keyof typeof paymentStatusEnumMapEnum;
export type PaymentStatusEnumValues =
    (typeof paymentStatusEnumMapEnum)[PaymentStatusEnumKeys];

export const PaymentStatusEnum: PaymentStatus extends PaymentStatusEnumValues
    ? typeof paymentStatusEnumMapEnum
    : never = paymentStatusEnumMapEnum;
